import { Bell } from "lucide-react";

/** Botao do sino do cabecalho (desktop). Sem aviso: discreto. Com aviso: cor da
 *  loja + numero. Urgente (fila ou fatura vencida/trial acabando): vermelho e
 *  pulsando. `total` = fila de atendimento + avisos (fatura, trial, Meta). */
export default function SinoNotificacoes({ total, urgente, title, onClick }) {
  const tem = total > 0;
  const cor = urgente
    ? "text-red-500 bg-red-500/10 hover:bg-red-500/20 animate-pulse motion-reduce:animate-none"
    : tem
      ? "text-primary bg-primary/10 hover:bg-primary/20"
      : "text-muted-foreground hover:text-foreground hover:bg-muted";
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={tem ? `Notificações: ${total} aviso${total === 1 ? "" : "s"}` : "Notificações"}
      data-e2e="sino-notificacoes"
      className={`relative flex items-center justify-center w-10 h-10 rounded-full transition-all ${cor}`}
    >
      <Bell className={`w-5 h-5 ${tem && !urgente ? "animate-sino-tocando" : ""}`} />
      {tem && (
        <span
          data-e2e="sino-contagem"
          className={`absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full text-white text-[10px] font-bold tabular-nums flex items-center justify-center ring-2 ring-background ${urgente ? "bg-red-500" : "bg-primary"}`}
        >
          {total > 99 ? "99+" : total}
        </span>
      )}
    </button>
  );
}
